
<div class="p-3">


  <div class="d-flex justify-content-between align-items-center mb-3">
    <h3 class="m-0 fs-24 fw-700 text-secondary mb-3">Training Details</h3>
    <div class="d-flex align-items-center">
      <button class="btn btn-primary btn-sm me-3 cursor" [disabled]="['5','7','6','8','4','9'].includes(trainingStatus)"
        (click)="changeAssignee()">Change
      Assignee</button>

      @if (!((!trainingInfo || !trainingInfo.training_event_time_slot_id) && api_hit == false)) {
        <button class="btn btn-primary btn-sm me-3"
        (click)="editTrainingModal()">Edit Training Details</button>
      }
      <!--<button class="btn btn-primary btn-sm ml-1" (click)="addTrainingNotesModal()">Add Note</button>-->
      @if (!detail_in_notification && !req_id) {
        <button class="btn btn-primary btn-sm"
        (click)="goBack()">Back</button>
      }
    </div>
  </div>
  @if (trainingInfo && !((!trainingInfo || !trainingInfo.training_event_time_slot_id) && api_hit == false)) {
    <div class="card card-default mb-3">
      <div class="card-body">
        <div>
          <div class="row">
            <!--Training Information-->
            <div class="col-12 mt-2 m-0 fs-20 fw-700">Training Information</div>
            <div class="col-4">
              <span class="text-muted training_attributes">Date:</span>
              {{trainingInfo.schedule_date ? (trainingInfo.schedule_date) : 'N.A.'}}
            </div>
            <div class="col-4">
              <span class="text-muted training_attributes">Time:</span>
              {{trainingInfo.schedule_time ? trainingInfo.schedule_time : 'N.A.'}}
            </div>
            <div class="col-4">
              <span class="text-muted training_attributes">Timezone:</span>
              @if (timezoneName || trainingInfo.timezoneString) {
                <span>
                  {{timezoneName + '(GMT'+trainingInfo.timezoneString+')'}}
                </span>
              }
              @if (!(timezoneName || trainingInfo.timezoneString)) {
                <span>
                  N.A.
                </span>
              }
            </div>
            <div class="col-4">
              <span class="text-muted training_attributes">Assigned to:</span>
              @if (trainingInfo.admin_name || trainingInfo.admin_email) {
                <span>
                  {{trainingInfo.admin_name + ' ('+trainingInfo.admin_email+')'}}
                </span>
              }
              @if (!(trainingInfo.admin_name || trainingInfo.admin_email)) {
                <span>
                  N.A.
                </span>
              }
            </div>
            <div class="col-4">
              <span class="text-muted training_attributes">Type of Training: </span>
              <span>{{trainingInfo.type_name || 'N.A.'}}</span>
              <!-- <span *ngIf="trainingInfo.type ==1">Initial Training</span>
              <span *ngIf="trainingInfo.type ==2">Refresher Training</span>
              <span *ngIf="trainingInfo.type ==3">New Feature Training</span>
              <span *ngIf="trainingInfo.type ==4">Demo</span> -->
            </div>
            <div class="col-4">
              <span class="text-muted training_attributes">Status: </span>
              <span>{{trainingInfo.training_status_name || 'N.A.'}}</span>
              <!--<span *ngIf="trainingInfo.status == 1">New Registration</span>
              <span *ngIf="trainingInfo.status == 2">Scheduled</span>
              <span *ngIf="trainingInfo.status == 3">Rescheduled</span>
              <span *ngIf="trainingInfo.status == 4">Follow up</span>
              <span *ngIf="trainingInfo.status == 5">Completed</span>
              <span *ngIf="trainingInfo.status == 6">No show</span>
              <span *ngIf="trainingInfo.status == 7">Canceled</span>-->
            </div>
            @if ((trainingInfo.training_status == 4 || trainingInfo.training_status == 9) && trainingInfo.followup_date) {
              <div class="col-4">
                <span class="text-muted training_attributes">Follow Up: </span>
                <!-- <span>{{trainingInfo.followup_date | date: 'MM/dd/yyyy': timezone}}</span>  why i'm commenting this please refer FM-3049 -->
                <span >{{trainingInfo.followup_date | date: 'MM/dd/yyyy': "+0000"}}</span>
              </div>
            }
            <div class="col-4">
              <span class="text-muted training_attributes">Source: </span>
              @if (trainingInfo.training_source == 'doctor') {
                <span class="camel_case_string">Business ({{trainingInfo.schedule_name ? trainingInfo.schedule_name : trainingInfo.training_doctor_partner_name}})</span>
              }
              @if (trainingInfo.training_source != 'doctor' && trainingInfo.training_source != 'admin') {
                <span class="camel_case_string">{{trainingInfo.training_source ? trainingInfo.training_source : 'admin'}} ({{trainingInfo.schedule_name ? trainingInfo.schedule_name : ' '}})</span>
              }
              @if (trainingInfo.training_source == 'admin') {
                <span class="camel_case_string">{{trainingInfo.training_source ? trainingInfo.training_source : 'admin'}} ({{trainingInfo.schedule_name ? trainingInfo.schedule_name : trainingNotes[trainingNotes.length-1].creator_admin_name}})</span>
              }
            </div>
            <div class="col-4">
              <span class="text-muted training_attributes">Note: </span>
              @if (trainingInfo.training_timezone_short_name) {
                <span>This training was originally booked in {{trainingInfo.training_timezone_short_name}} for
                {{trainingInfo.training_start_timestamp ? getDateTimeFromTimestampWithFormat(trainingInfo.training_start_timestamp, 'MM/DD/YYYY hh:mm A', trainingInfo.training_timezone_offset) : ''}}</span>
              }
              @if (!trainingInfo.training_timezone_short_name) {
                <span>N.A.</span>
              }
            </div>
            <div class="col-4">
              <span class="text-muted training_attributes">Meeting Link: </span>
              @if (trainingInfo.training_meeting_link) {
                <span><a target="_blank" href="{{trainingInfo.training_meeting_link}}">{{trainingInfo.training_meeting_link}}</a></span>
              }
              @if (!trainingInfo.training_meeting_link) {
                <span>N.A.</span>
              }
            </div>
            <!--Business Owner Information-->
            <div class="col-12 fs-20 fw-700">{{trainingInfo.training_doctor_partner_type == 'doctor' ? 'Business Owner' :'Partner'}} Information</div>
            @if (trainingInfo.training_doctor_partner_id != 0) {
              <div class="col-4">
                <span class="text-muted training_attributes">Name:</span>
                @if (trainingInfo.training_doctor_partner_type == 'doctor') {
                  <a [routerLink]="'/app/business/details/'+trainingInfo.training_doctor_partner_id">
                    {{trainingInfo.doctor_name}}
                  </a>
                }
                @if (trainingInfo.training_doctor_partner_type == 'partner') {
                  <a [routerLink]="'/app/partners/profile/'+trainingInfo.training_doctor_partner_id">
                    {{trainingInfo.partner_name}}
                  </a>
                }
                @if (trainingInfo.training_doctor_partner_type != 'partner' && trainingInfo.training_doctor_partner_type != 'doctor') {
                  <span>N.A.</span>
                }
              </div>
            }
            @if (trainingInfo.training_doctor_partner_id == 0) {
              <div class="col-4">
                <span class="text-muted training_attributes">Name:</span> {{trainingInfo.training_doctor_partner_name || 'N.A.'}}
              </div>
            }
            @if (trainingInfo.training_doctor_partner_id == 0) {
              <div class="col-4">
                <span class="text-muted training_attributes">Email:</span>
                {{trainingInfo.training_trainee_emails}}
              </div>
            }
            @if (trainingInfo.training_doctor_partner_id != 0) {
              <div class="col-4">
                <span class="text-muted training_attributes">Email:</span>
                @if (trainingInfo.training_doctor_partner_type == 'partner') {
                  <span>
                    {{trainingInfo.partner_email || 'N.A.'}}
                  </span>
                }
                @if (trainingInfo.training_doctor_partner_type != 'partner') {
                  <span>
                    {{trainingInfo.doctor_email || 'N.A.'}}
                  </span>
                }
              </div>
            }
            <div class="col-4">
              <span class="text-muted training_attributes">Mobile:</span>
              @if (trainingInfo.training_doctor_partner_type == 'partner') {
                <span>
                  {{trainingInfo.partner_mobile?(trainingInfo.partner_mobile | phoneFormat ) : trainingInfo.training_doctor_partner_phone ? (trainingInfo.training_doctor_partner_phone | phoneFormat ) : 'N.A.'}}
                </span>
              }
              @if (trainingInfo.training_doctor_partner_type != 'partner') {
                <span>
                  {{trainingInfo.doctor_mobile?(trainingInfo.doctor_mobile | phoneFormat ): trainingInfo.training_doctor_partner_phone?(trainingInfo.training_doctor_partner_phone | phoneFormat) : 'N.A.'}}
                </span>
              }
            </div>
            <div class="col-4">
              <span class="text-muted training_attributes">Type:</span> {{trainingInfo.training_doctor_partner_id != 0?'Registered':'Unregistered'}}
            </div>
            <!--Business Information-->
            @if (trainingInfo.training_doctor_partner_type == 'doctor') {
              <div class="col-12 mt-2 fs-20 fw-700">Business Information</div>
              <div class="col-4">
                <span class="text-muted training_attributes">Name:</span> {{(trainingInfo.training_practice_name)|| 'N.A.'}}
              </div>
              <div class="col-4">
                <span class="text-muted training_attributes">Email:</span> {{(trainingInfo.practice_email) || 'N.A.'}}
              </div>
              <div class="col-4">
                <span class="text-muted training_attributes">Mobile:</span>
                {{trainingInfo.practice_mobile?(trainingInfo.practice_mobile | phoneFormat ) : 'N.A.'}}
              </div>
            }
            <!--Agent Information-->
            @if (trainingInfo.training_agent_id) {
              <div class="col-12 mt-2 fs-20 fw-700">Agent Information</div>
            }
            @if (trainingInfo.training_agent_id) {
              <div class="col-4">
                <span class="text-muted training_attributes">Name:</span> {{(trainingInfo.training_agent_name)|| 'N.A.'}}
              </div>
            }
            @if (trainingInfo.training_agent_id) {
              <div class="col-4">
                <span class="text-muted training_attributes">Email:</span> {{(trainingInfo.training_agent_email) || 'N.A.'}}
              </div>
            }
          </div>
          @if (trainingNotes.length) {
            <div class="mt-3">
              <div><b>CSR Note</b></div>
              <span>{{trainingNotes[trainingNotes.length-1].creator_admin_name || 'Added by
                '+(trainingNotes[trainingNotes.length-1].training_agent_id ? 'Agent' : 'Business')}} |
                {{trainingNotes[trainingNotes.length-1].doctor_partner_training_status_date_created | date:'MM/dd/yyyy hh:mm
                a':timezone}}{{trainingNotes[trainingNotes.length-1].training_status_name ? ' |
              '+trainingNotes[trainingNotes.length-1].training_status_name : '' }}</span>
              <p class="speech-bubble speech-bubble-full show-enter" [innerHTML]="$safeNavigationMigration(trainingNotes[trainingNotes.length-1].training_event_desc?.replaceAll('\n','<br\>'))"></p>
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (trainingNotes && trainingNotes.length) {
    <div class="card card-default mb-3">
      <div class="card-header">Notes</div>
      <div class="card-body">
        @for (note of trainingNotes; track note) {
          <div class="row">
            <div class="col">
              <p>{{note.creator_admin_name || 'Added by '+(note.training_agent_id ? 'Agent' : 'Business')}} | {{note.doctor_partner_training_status_date_created | date:'MM/dd/yyyy hh:mm a':timezone}}{{note.training_status_name ? ' | '+note.training_status_name : '' }}</p>
            <p class="speech-bubble show-enter" [innerHTML]="$safeNavigationMigration(note.training_event_desc?.replaceAll('\n','<br/>'))"></p>
            <!-- <p class="speech-bubble show-enter"  [textContent]="note.training_event_desc" style="white-space: pre-line;"></p> -->
          </div>
        </div>
      }
    </div>
  </div>
}
@if ((!trainingInfo || !trainingInfo.training_event_time_slot_id) && api_hit == false) {
  <div class="card card-default">
    <div class="card-body">
      <div>
        <div class="wrapper">
          <div class="abs-center wd-xl">
            <div class="text-center mb-4">
              <div class="mb-3" style="font-size: 50px;">Oops!</div>
              <p class="lead m0">The training is no longer exists.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>
<!--Add Note-->
<!-- <div bsModal #addNoteModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
aria-hidden="true">
<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <form #addNoteForm="ngForm" (ngSubmit)="addNoteForm.valid && addNote(addNoteForm, addNoteModal)">
      <div class="modal-header">
        <h4 class="modal-title">Add Note</h4>
        <button type="button" class="close" aria-label="Close" (click)="addNoteModal.hide()">
          &times;
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group"
          [ngClass]="{'has-error': (addNoteForm.submitted && new_note.invalid) || (new_note.touched && new_note.invalid)}">
          <label for="new_note">Note</label>
          <textarea id="new_note" cols="30" rows="4" [(ngModel)]="newNote" #new_note="ngModel" required
          name="new_note" class="form-control" placeholder="Enter note here..."></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <div class="d-flex">
          <div>
            <button type="button" class="btn btn-outline-secondary mr-4" (click)="addNoteModal.hide();newNote=''">Cancel</button>
          </div>
          <div class="ml-auto">
            <button type="submit" class="btn btn-primary">Confirm</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
</div> -->